import { notEmptyObject } from '@/utils/notEmptyObject';

export default {
  getIsNoBasketEdit(state, getters) {
    return !state.basketEdit?.state;
  },

  getNotEmptySumCalculate(state, getters) {
    return notEmptyObject(state.sumCalculate);
  },

  getIsNotEmptySumCalculateAboveZero(state, getters) {
    return getters.getNotEmptySumCalculate > 0;
  },
};
